export const formatNumber = (val: any, dec = 0, {default0, prefix = '', suffix = '', maxDec, minDec}: any = {}) => {
  let num = Number(val);
  const defaultVal = default0 ?? 0;
  if (!num || isNaN(num) || num === Infinity) {
    if (typeof defaultVal === 'number') {
      num = defaultVal;
    } else {
      return defaultVal;
    }
  }
  
  const isNegative = num < 0;
  const absNum = Math.abs(num);
  const formattedNum = absNum.toLocaleString('en-US', {minimumFractionDigits: minDec ?? dec ?? 0, maximumFractionDigits: maxDec ?? dec ?? 0});
  
  return (isNegative ? '-' : '') + prefix + formattedNum + suffix;
};

export const formatDollars = (
  val: any, 
  { dec = 0, maxDec, minDec, default0 = '$0', prefix = '$', suffix = '' }: { dec?: number, maxDec?: number, minDec?: number, default0?: string | null, prefix?: string, suffix?: string } = {}
) => {
  return formatNumber(val, dec, { default0, prefix, suffix, minDec, maxDec });
};